import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import VueAxios from 'vue-axios';
// Requests
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';
import './filters';
import LogRocket from 'logrocket';

import Image from '@npm/image';
// import '@npm/image/dist/style.css';

import store from '@/store';
import { logrocketId, sentryDsn } from '@/utils/envs';

import App from './App';
import api from './api';
import { getApiUrl, currentCountry } from './utils/starters';
import router from './router';
import routerGuard from './router/routerGuard';
import { COUNTRIES } from './utils/constants';
import headerClaro from './components/HeaderClaro';
import messages from './i18n';

import '@/directives/onlyNumbers';

LogRocket.init(logrocketId);
Vue.prototype.$LogRocket = LogRocket;

Vue.prototype.$store = store;

Sentry.init({
  dsn: sentryDsn,
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true
    }),
    new Integrations.BrowserTracing()
  ],
  tracesSampleRate: 0.001,
  ignoreErrors: [
    'Non-Error exception captured',
    'Non-Error promise rejection captured'
  ]
});

// import './registerServiceWorker'
Vue.config.productionTip = false;

global.api = api();
const axiosInstance = axios.create({
  baseURL: getApiUrl(),
  timeout: 2000000
});

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: COUNTRIES[currentCountry],
  fallbackLocale: COUNTRIES.GT,
  messages
});

Vue.use(VueAxios, axiosInstance);

Vue.component('HeaderClaro', headerClaro);
Vue.component('HtechImg', Image);

routerGuard(router);

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App)
}).$mount('#app');
